module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/thumbs/1-bb767cd55ab9936639081f472d3a591a.webp";